import { getMetaContent } from './dom';

export const website = __TEST__ ? 'https://example.com' : (getMetaContent('website') ?? 'https://example.com');
export const frontendPathname = new URL(website).pathname;
export const frontendOrigin = new URL(website).origin;

export const FABase = 'http://fontawesome.io/icon/';

export function isFontAwesomeIRI(iri?: string): boolean {
  return iri ? iri.startsWith(FABase) : false;
}

export function normalizeFontAwesomeIRI(str: string): string {
  return isFontAwesomeIRI(str) ? str.split(FABase).pop()! : str;
}

export const isDifferentOrigin = (originIRI: string | any): boolean => {
  const href = typeof originIRI === 'string' ? new URL(originIRI, frontendOrigin).toString() : originIRI;

  if (!href) {
    return false;
  }

  return !href.startsWith(frontendOrigin + '/');
};

/**
 * @param {string} pathString The path to process, e.g. `/path`.
 * @returns {undefined|string} The fully qualified URL.
 */
export const expandPath = (pathString: string | undefined): string | undefined => {
  if (!pathString) {
    return undefined;
  }

  return new URL(pathString, frontendOrigin).href;
};

export const isLocalAnchor = (iriString: string): boolean => iriString === '#';

export const isDifferentWebsite = (iri: string | URL): boolean => {
  if (isDifferentOrigin(iri)) {
    return true;
  }

  const url = typeof iri === 'string' ? iri : iri.toString();

  return !new URL(url, frontendOrigin).pathname.startsWith(frontendPathname);
};

/**
 * Returns only the pathname and beyond. Useful for relative navigation.
 * @param {string|NamedNode} iri The IRI to process.
 * @returns {string} The pathname and beyond.
 */
export const retrievePath = (iri: string): string => {
  if (isLocalAnchor(iri)) {
    return iri;
  }

  // TODO: https://github.com/linkeddata/rdflib.js/issues/265
  const bugNormalized = iri.replace(`${frontendOrigin}//`, `${frontendOrigin}/`);
  const url = new URL(bugNormalized, frontendOrigin);

  return url.pathname + url.search + url.hash;
};
export const retrieveParams = (url: string): string => `?${url.split('?')[1] || ''}`;

export default retrievePath;
